// extracted by mini-css-extract-plugin
export default {"container":"HistoryChart_container__zqwFX"};